import { useLiveSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useLiveSummary';
import { LiveSummaryApiConnector } from 'components/common-form/sidePanel/docToolbar/summary/mailSender/MailSenderSecondary.apiconnectors';
import type { LiveSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/liveSummaryMailRequest';
import { FormattedMessage } from 'components/shared/Intl';
import { useUserNotification } from 'hooks/useUserNotification';
import { FC } from 'react';
import { lastValueFrom } from 'rxjs';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { httpClient } from 'utils/http/httpClient';

type MailSenderLiveSecondaryProps = { tabId: string };

export const SummaryMailSenderLiveSecondary: FC<MailSenderLiveSecondaryProps> = ({ tabId }) => {
  const liveSummaryMailRequestProps = useLiveSummary(tabId);
  const notification = useUserNotification();

  const sendLiveHtmlEmail = (): void => {
    const htmlRequest: LiveSummaryMailRequest = {
      ...liveSummaryMailRequestProps,
      isTrade: false,
    };

    lastValueFrom(LiveSummaryApiConnector(httpClient).sendMailInHtmlFormat(htmlRequest)).then(
      onMailSentWithSuccess,
      onMailSentWithError,
    );
  };

  const logAnalyticsCategory = 'Secondary market';
  const onMailSentWithError = (_: Error): void => {
    notification.error({
      title: { id: 'toast.mail' },
      content: [{ id: 'mailSentWithError' }],
      closeAutomatically: false,
    });
  };

  const onMailSentWithSuccess = (): void => {
    notification.success({ title: { id: 'toast.mail' }, content: [{ id: 'mailSentWithSuccess' }] });
  };

  const onSendToMe = (): void => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Send mail to me');
    sendLiveHtmlEmail();
  };

  return (
    <button className="btn btn-xl btn-primary" onClick={onSendToMe} data-e2e="sendToMe-secondary-product-summary">
      <FormattedMessage id="sendToMe" />
    </button>
  );
};
